var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"poster-box"},[_c('div',{staticClass:"poster"},[_c('van-image',{staticClass:"poster-img",attrs:{"src":_vm.posterUrl}})],1)]),_c('div',{staticClass:"save-box"},[_c('div',{staticClass:"save",on:{"click":_vm.savePoster}},[_vm._v("保存本地")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }